import type { SurfData } from 'types/surf';
import { doesObservationMatchForecastTimestamps } from 'utils/surfObservationMatch';

const updateMaxHeight = (currentMax: number, height?: number | null) =>
  height != null && Number.isFinite(height) ? Math.max(currentMax, height) : currentMax;

/**
 * Returns the largest raw surf height across the forecast window for Y-scale domain.
 * Points continue to plot raw heights; this only sets the scale so bars and
 * observations stay in proportion across all forecast days.
 * Observations only contribute when they match a forecast timestamp within the shared
 * 5-minute tolerance used by SurfTooltip and the graph renderer.
 */
export const getMaxSurfGraphHeight = ({ days, observations }: SurfData) => {
  let maxHeight = 0;
  const forecastTimestamps = new Set<number>();

  days.forEach((day) => {
    day.forEach(({ surf, timestamp }) => {
      forecastTimestamps.add(timestamp);
      maxHeight = updateMaxHeight(maxHeight, surf.raw?.max);
    });
  });

  observations?.forEach(({ surf, timestamp }) => {
    if (!doesObservationMatchForecastTimestamps(timestamp, forecastTimestamps)) return;
    maxHeight = updateMaxHeight(maxHeight, surf?.raw?.max);
  });

  return maxHeight;
};

export default getMaxSurfGraphHeight;
